import CUSTOM_THEME from '@features/theme/theme'

import Config from '@features/config.json'

const haveHeader = Config.interface?.header ?? true
const haveLeftPanel = Config.interface?.leftPanel ?? true

const THEME = {
    ...CUSTOM_THEME,
    global: {
        disabledOpacity: 0.5,
        drawerWidth: (haveLeftPanel) ? '280px' : 0,
        radius: '8px',
        menuPaddingRight: '0px',
        menuMarginLeft: '0px',
        ...CUSTOM_THEME?.global
    },
    radio: {
        icon: 'circle',
        checkedIcon: 'trip_origin',
        ...CUSTOM_THEME?.radio
    },
    checkbox: {
        icon: 'check_box_outline_blank',
        checkedIcon: 'check_box',
        ...CUSTOM_THEME?.checkbox
    },
    link: {
        externalIcon: 'open_in_new',
        internalIcon: 'trending_flat',
        ...CUSTOM_THEME?.link
    },
    search: {
        icon: 'search',
        resetIcon: 'close',
        ...CUSTOM_THEME?.Textinput?.Search
    },
    menuLeft: {
        radius: 0,
        ...CUSTOM_THEME?.menuLeft
    },
    header: {
        position: 'fixed',
        width: '100vw',
        height: (haveHeader) ? '64px' : 0,
        buttonMinHeight: '32px',
        borderRadius: '32px',
        fontWeight: 600,
        fontSize: '14px',
        ...CUSTOM_THEME?.header,
        style: {
            ...CUSTOM_THEME?.header?.style
        }
    },
    headerSubmenu: {
        ...CUSTOM_THEME?.headerSubmenu,
        style: {
            paddingTop: 0,
            paddingBottom: 0,
            borderRadius: '3px',
            minWidth: '200px',
            ...CUSTOM_THEME?.headerSubmenu?.style
        }
    },
    headerSubmenuItem: {
        ...CUSTOM_THEME?.headerSubmenuItem,
        style: {
            minHeight: '40px !important',
            fontWeight: '600 !important',
            fontSize: '14px',
            lineHeight: '20px',
            ...CUSTOM_THEME?.headerSubmenuItem?.style
        }
    },
    Datatable: {
        radius: '4px',
        emptyIcon: 'troubleshoot',
        emptyText: 'No data available',
        ...CUSTOM_THEME?.Datatable
    },
    components: {
        ...CUSTOM_THEME?.components,
        MuiButton: {
            ...CUSTOM_THEME?.components?.MuiButton,
            styleOverrides: {
                ...CUSTOM_THEME?.components?.MuiButton?.styleOverrides,
                root: {
                    textTransform: 'none',
                    borderRadius: '32px',
                    ...CUSTOM_THEME?.components?.MuiButton?.styleOverrides?.root
                }
            },
            variant: {
                universe: {
                    fontWeight: 700,
                    fontSize: '16px'
                }
            }
        },
        MuiLink: {
            ...CUSTOM_THEME?.components?.MuiLink,
            variant: {
                ...CUSTOM_THEME?.components?.MuiLink?.variant,
                primary: {
                    defaultBorderBottom: '1px solid',
                    hoverBorderBottom: '2px solid',
                    disabledBorderBottom: '1px solid',
                    ...CUSTOM_THEME?.components?.MuiLink?.variant?.primary,
                }
            }
        }
    }
}

export default THEME